import { FC, useContext } from "react";
import { ArticleContext } from "../../Context";
import { articleTypes } from "../../Context/ArticleContext";
import { Image, Wrapper } from "./SponsorImage.styled";
import { sanitiseUrl } from "common/Utils/sanitiseUrl";

interface Props {
  type: string;
}

const SponsorImage: FC<Props> = ({ type }) => {
  const { refactoredArticle } = useContext<articleTypes>(ArticleContext);
  const { sponsorPrefix, sponsorImage, sponsorURL } = refactoredArticle;
  if (!sponsorImage) {
    return null;
  }
  if (!sponsorImage.data) {
    return null;
  }

  if (!sponsorImage.data.url) {
    return null;
  }
  if (!sponsorURL) {
    return null;
  }

  return (
    <Wrapper type={type}>
      {sponsorPrefix && (
        <a
          target="_blank"
          href={sanitiseUrl(sponsorPrefix.url)}
          rel="noreferrer"
        >
          {" "}
          {sponsorPrefix.name}
        </a>
      )}
      <a target="_blank" href={sanitiseUrl(sponsorURL)} rel="noreferrer">
        <Image src={sponsorImage.data.url} />
      </a>
    </Wrapper>
  );
};

export default SponsorImage;
